import { Div } from '../../../base/components/native/div'
import services from '../../../services'
import { Redemm } from './redeem'
import { Redemptions } from './redemptions'

export const UserOperation = () => {

    const base = Div('')
    base.cssClass({
        width: '35%',
        padding: '20px 20px 20px 20px',
        textAlign: 'center',
    })

    return Object.assign(base, {
        async fill(user: any) {
            base.text(user.name)
            const p = await services.cashback.getPoints(user._id)
            const r = await services.cashback.getRedemptions(user._id)
            console.log({ p, r })

            const points = Div('Points: ' + ((p.totalCashbackPoints - r.totalRedemption).toFixed(2) || '0'))
            const redeem = Redemm()
            const redemptions = Redemptions()
            redemptions.fill(r.transactions)
            redeem.on('submit', async (value: number) => {
                const result = await services.cashback.redeem(user._id, { amount: value })
                redemptions.fill([result, ...r.transactions])
                points.text('Points: ' + (p.totalCashbackPoints - r.totalRedemption- value).toFixed(2))
                // amount        : 
                // 4
                // at
                // : 
                // "2023-03-25T19:53:31.047Z"
                // phone
                // : 
                // "+31687754381"
                // user
                // : 
                // "ardeshir.valipoor@gmail.com"
                // userId
                // : 
                // "625f12137d3c24301c5d52cd"
                // _id
                // : 
                // "641f513b373b5aded2268ed4"
                
            })
            base.append(points, redeem, redemptions)
        }
    })
}